import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'

import * as Partials from './partials'
import * as UI from '../components'
import { dataToArray } from '../helpers'

class ReceiptSidebar extends React.Component {
  render() {
    const { purchases, storefronts } = this.props

    return (
      <div>
        {purchases && (
          <UI.Card>
            <UI.Text size="large" weight="semiBold">
              Past Purchases
            </UI.Text>

            <UI.Divider />

            <Partials.PurchasesList
              purchases={dataToArray(purchases).sort(
                (a, b) => new Date(b.initiatedTime) - new Date(a.initiatedTime)
              )}
              storefronts={storefronts}
            />
          </UI.Card>
        )}
      </div>
    )
  }
}

const watches = props => []

const selectors = createStructuredSelector({
  purchases: ({ firebase }) => firebase.data.purchases,
  storefronts: ({ firebase }) => firebase.data.storefronts,
})

export default compose(connect(selectors), firebaseConnect(watches))(
  ReceiptSidebar
)



// WEBPACK FOOTER //
// ./src/screens/ReceiptSidebar.js